import { render, staticRenderFns } from "./comp_CheckoutStep-confirm--done.vue?vue&type=template&id=cec56dec&"
import script from "./comp_CheckoutStep-confirm--done.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-confirm--done.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports